module.exports = __webpack_public_path__ + "img/xcx.0d9a7692.jpg";